import {
  Button,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
} from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";
import GKModal from "components/GKModal";
import GKTextField from "components/GKTextField";
import { useForm } from "react-hook-form";
import { MdDelete } from "react-icons/md";
import axiosInstance from "utils/axiosInstance";
import { theme } from "utils/Theme";

const CreateModule = (props) => {
  const { inModuleOpen, setIsModuleOpen, moduleData } = props;

  const { data, refetch } = useQuery({
    queryKey: ["GET-FAQ-MODULE"],
    queryFn: () => axiosInstance.get("/faq-modules/"),
    onError: () => {},
  });

  const { mutate, isLoading } = useMutation({
    mutationKey: ["CREATE_MODULE"],
    mutationFn: (data) => axiosInstance.post(`/faq-modules/`, data),
    onSuccess: () => {
      refetch();
      setIsModuleOpen(false);
    },
  });

  const { mutate: deleteMutation } = useMutation({
    mutationKey: ["DELETE_MODULE"],
    mutationFn: (id) => axiosInstance.delete(`/faq-modules/${id}/`),
    onSuccess: () => {
      refetch();
    },
  });

  const { register, handleSubmit, reset } = useForm({
    defaultValues: {
      question: moduleData?.question || "",
    },
  });

  const onSubmit = (values) => {
    mutate({
      module_name: values.question,
    });
    reset();
  };

  return (
    <GKModal
      open={inModuleOpen}
      setOpen={setIsModuleOpen}
      modalTitle={"Add Module Details"}
      footer={
        <Grid container justifyContent={"flex-end"} gap={1}>
          <Button
            sx={{
              fontSize: "0.7rem",
              fontFamily: '"Arial", sans-serif',
              textTransform: "none",
            }}
            variant="outlined"
            onClick={() => setIsModuleOpen(false)}
          >
            Close
          </Button>
          <Button
            sx={{
              fontSize: "0.7rem",
              fontFamily: '"Arial", sans-serif',
              textTransform: "none",
            }}
            variant="contained"
            form="create-Module"
            type="submit"
          >
            {isLoading ? <CircularProgress size={20} /> : "Submit"}
          </Button>
        </Grid>
      }
    >
      <form onSubmit={handleSubmit(onSubmit)} id="create-Module">
        <Grid item xs={12}>
          <FormControl variant="standard" fullWidth>
            <GKTextField
              inputLabel="Question"
              {...register("question")}
              name="question"
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          {data?.data?.data?.map((dataItem) => (
            <Grid
              container
              p={1}
              m={1}
              border={`solid 1px ${theme.palette.primary.main}22`}
              alignItems={"center"}
              borderRadius={0}
              key={dataItem.id}
            >
              <Grid item xs={6}>
                {dataItem.moduleName || ""}
              </Grid>
              <Grid item xs={6} textAlign={"right"}>
                <IconButton
                  color="error"
                  onClick={() => {
                    deleteMutation(dataItem.id);
                  }}
                >
                  <MdDelete />
                </IconButton>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </form>
    </GKModal>
  );
};

export default CreateModule;
